<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" v-if="loading">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <form
              v-if="!loading"
              @submit.prevent="onSubmit"
              novalidate
              enctype="multipart/form-data"
              :class="
                submitted
                  ? 'needs-validation was-validated'
                  : 'needs-validation'
              "
            >
              <input
                type="hidden"
                name="csrfmiddlewaretoken"
                value="0L0MOfRBuk6BgP4wYfzXKsCvZO5V1fspTKQaB524JIThSNA8FIoLwLJBlZZsHhV0"
              />

              <h4 class="card-title">Address Information</h4>
              <p></p>

              <!-- Start Row -->
              <div class="row">
                <!-- Start Col -->
                <div class="col-lg-6">
                  <label for="address_street_id">Address Street*</label>
                  <input
                    type="text"
                    name="address_street"
                    id="address_street_id"
                    class="form-control"
                    maxlength="255"
                    required=""
                    v-model.trim="$v.address_street.$model"
                  />
                  <div
                    v-if="submitted && !$v.address_street.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>
                <!-- End Col -->

                <!-- Start Col -->
                <div class="col-lg-6">
                  <label for="zip_code_id">ZIP Code*</label>
                  <input
                    type="text"
                    name="zip_code"
                    id="zip_code_id"
                    class="form-control"
                    maxlength="10"
                    required=""
                    v-model.trim="$v.zip_code.$model"
                  />
                  <div
                    v-if="submitted && !$v.zip_code.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>
                <!-- End Col -->
              </div>
              <!-- End Row -->

              <p></p>

              <!-- Start Row -->
              <div class="row">
                <!-- Start Col -->
                <div class="col-lg-6">
                  <label for="city_id">City*</label>
                  <input
                    type="text"
                    name="city"
                    id="city_id"
                    class="form-control"
                    maxlength="255"
                    required=""
                    v-model.trim="$v.city.$model"
                  />
                  <div
                    v-if="submitted && !$v.city.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>
                <!-- End Col -->

                <!-- Start Col -->
                <div class="col-lg-6">
                  <label for="state_id">State*</label>
                  <v-select
                    v-model.trim="$v.state.$model"
                    :options="options"
                  ></v-select>
                  <div
                    v-if="submitted && !$v.state.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>
                <!-- End Col -->
              </div>
              <!-- End Row -->

              <p></p>
              <h4 class="card-title">ORGANIZATION</h4>
              <p></p>

              <!-- Start Row -->
              <div class="row">
                <!-- Start Col -->
                <div class="col-lg-6">
                  <label for="organization_id">Organization*</label>
                  <v-select
                    v-if="!$route.query.org_id"
                    :disabled="isFixedOrg"
                    v-model.trim="$v.organization.$model"
                    :options="organizationList"
                    multiple
                  ></v-select>

                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="organization[0].label"
                    v-if="$route.query.org_id"
                  />

                  <!-- <div
                    v-if="submitted && !$v.organization.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div> -->
                </div>
                <!-- End Col -->

                <!-- Start Col -->
                <div class="col-lg-6">
                  <label for="">Address Type</label>
                  <ul id="address_type_id" class="checkbox inline">
                    <li>
                      <label for="address_type_id_0"
                        ><input
                          type="checkbox"
                          name="address_type"
                          value="service_location"
                          id="address_type_id_0"
                          class="checkbox inline"
                          v-model.trim="$v.address_type.$model"
                        />
                        Service Location</label
                      >
                    </li>
                    <li>
                      <label for="address_type_id_1"
                        ><input
                          type="checkbox"
                          name="address_type"
                          value="billing_address"
                          id="address_type_id_1"
                          class="checkbox inline"
                          v-model.trim="$v.address_type.$model"
                        />
                        Billing Address</label
                      >
                    </li>
                    <li>
                      <label for="address_type_id_2"
                        ><input
                          type="checkbox"
                          name="address_type"
                          value="headquarters"
                          id="address_type_id_2"
                          class="checkbox inline"
                          v-model.trim="$v.address_type.$model"
                        />
                        Headquarters</label
                      >
                    </li>
                  </ul>
                  <!-- <div
                    v-if="submitted && !$v.address_type.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div> -->
                </div>
                <!-- End Col -->
              </div>
              <!-- End Row -->

              <p></p>

              <!-- Start Button -->
              <div class="d-flex flex-wrap gap-2">
                <button
                  class="btn btn-success"
                  :disabled="loadingAction"
                  type="submit"
                >
                  Save
                </button>
                <button type="button" class="btn btn-light waves-effect" @click="$router.go(-1)">
                  <!-- <router-link to="/mpg/addresses"></router-link> -->
                  Cancel
                </button>
              </div>
              <!-- End Button -->
            </form>
            <!-- End Form -->
          </div>
          <!-- End Card Body -->
        </div>
        <!-- End Card -->
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { addressesService } from '../services/addresses.service'
import { utilService } from '../services/util.service'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { router } from '../router'

export default {
  name: 'AddAddresses',
  components: {},
  data () {
    return {
      loadingAction: false,
      state: '',
      options: [],
      organizationList: [],
      organization: '',
      address_street: '',
      zip_code: '',
      city: '',
      address_type: [],
      submitted: false,
      loading: true,
      error: '',
      isFixedOrg: false
    }
  },
  validations: {
    organization: {},
    state: { required },
    address_street: { required },
    zip_code: { required },
    city: { required },
    address_type: {}
  },
  computed: {},
  created () {
    utilService.getState().then((rs) => {
      this.options = rs.results.map((e) => {
        e.label = e.acronym
        e.code = e.state_id
        return e
      })
    })
    organizationsService
      .getData({
        q: '',
        limit: '999999999',
        ordering: '',
        offset: 0,
        expands: ''
      })
      .then((rs) => {
        this.loading = false
        this.organizationList = rs.results.map((e) => {
          e.label = e.name
          e.code = e.organization_id

          if (
            this.$route.query.org_id &&
            e.organization_id.toString() === this.$route.query.org_id
          ) {
            this.isFixedOrg = true
            this.organization = []
            this.organization.push(e)
          }

          return e
        })
      })
  },
  methods: {
    moment,
    onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      //
      this.loadingAction = true
      const payload = {
        state: this.state.code,
        address_street: this.address_street,
        zip_code: this.zip_code,
        city: this.city
      }

      addressesService.add(payload).then(
        (rs) => {
          if (this.organization === '' || this.organization.length === 0) {
            this.$bvToast.toast('Add successfully.', {
              title: `Update`,
              variant: 'primary',
              solid: true
            })
            this.$nextTick(() => {
              if (this.$route.query.org_id) {
                router.push('/mpg/organizations/' + this.$route.query.org_id + '/addresses')
              } else {
                router.push('/mpg/addresses/' + rs.address_id + '/details')
              }
            })
            return
          }
          Promise.all(
            this.organization.map((org) => {
              return addressesService
                .addOrgToAddress({
                  address_type: this.address_type,
                  property_status: 'active',
                  address: rs.address_id,
                  organization: org.code
                })
                .then((data) => {
                  return data
                })
            })
          )
            .then((values) => {
              this.$bvToast.toast('Add successfully.', {
                title: `Update`,
                variant: 'primary',
                solid: true
              })
              this.$nextTick(() => {
                if (this.$route.query.org_id) {
                  router.push(
                    '/mpg/organizations/' + this.$route.query.org_id + '/addresses'
                  )
                } else {
                  router.push('/mpg/addresses/' + rs.address_id + '/details')
                }
              })
            })
            .catch((e) => {
              this.$bvToast.toast('Error.', {
                title: `Error`,
                variant: 'danger',
                solid: true
              })
              this.loadingAction = false
            })
        },
        (error) => {
          this.error = error
          this.loadingAction = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AddAddresses.vue